export const STUDENT_INFO = "/student-info/v1";
export const STUDENT_INFO_BUS_ROUTE = `${STUDENT_INFO}/busRoute`; // {$studentNumber}/detail.json
export const STUDENT_INFO_CURRENT_ENROLLMENT = `${STUDENT_INFO}/currentEnrollment`; // {studentNumber}/detail.json
export const STUDENT_INFO_CUSTOM_ATTRIBUTES = `${STUDENT_INFO}/attributes`; // {studentNumber}/index.json
export const STUDENT_INFO_CUSTOM_ATTRIBUTE_CREATE = `${STUDENT_INFO}/addCustomAttribute`; // {studentNumber}/detail.json
export const STUDENT_INFO_GET = `${STUDENT_INFO}/studentNumber`;
export const STUDENT_INFO_SAE_OPT_OUTS = `${STUDENT_INFO}/optOut/byStudentNumber`; // /{studentNumber}/{schoolYearId}/index.json`
export const STUDENT_INFO_STUDENT = `${STUDENT_INFO}/student`;
export const STUDENT_INFO_GUARDIAN = `${STUDENT_INFO}/guardian`;
export const STUDENT_INFO_GUARDIAN_CONTACT_UPDATE = `${STUDENT_INFO_GUARDIAN}/updateContact/detail.json`;
export const STUDENT_INFO_GUARDIAN_HOUSEHOLD = `${STUDENT_INFO_GUARDIAN}/household`;
export const STUDENT_INFO_REFERENCE_DATA = `${STUDENT_INFO}/reference_data/campus_dictionary`; // {attributeName}/{objectName}/index.json
export const STUDENT_INFO_INDIVIDUAL_PERSON_READ = `${STUDENT_INFO}/reference_data/individual`; // {personId}/detail.json
export const STUDENTS_BY_GUARDIAN_GET = `${STUDENT_INFO}/guardian/students`; // /{userName}/index.json

export const CUSTOM_STUDENT_ATTRIBUTE_IDS_PRI = {
    772: "armed_forces",
    921: "check_online",
    7182: "CommOptionPrimary",
    1669: "Instructional Media",
    1670: "Media Coverage",
    586: "MedicaidConsent",
    1131: "parent_code_of_conduct",
    7469: "parent_guide",
    1668: "Publish Basic Student Info"
};

export const CUSTOM_STUDENT_ATTRIBUTE_IDS_SEC = {
    1281: "check_online_sec",
    7183: "CommOptionSecondary"
};

export const getAttributeIds = (primSecFlag) => {
    if (primSecFlag === "PRIMARY") {
        return CUSTOM_STUDENT_ATTRIBUTE_IDS_PRI;
    }
    if (primSecFlag === "SECONDARY") {
        return CUSTOM_STUDENT_ATTRIBUTE_IDS_SEC;
    }

    return null;
};
